import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { translationRootUrl } from '@core/translation/models/translation-root-url';
import { fallbackLanguage } from '@core/language/models/fallback-language';
import { TranslationFacade } from '@core/translation/facades/translation.facade';

export const provideTranslations = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideTranslateService({
      loader: provideTranslateHttpLoader({ prefix: translationRootUrl, useHttpBackend: true }),
      fallbackLang: fallbackLanguage,
      lang: fallbackLanguage,
      extend: true,
    }),
    provideEnvironmentInitializer((): void => {
      inject(TranslationFacade).addTranslateService(inject(TranslateService));
    }),
  ]);
